import { createApp, nextTick } from "vue";
import { router } from "./routers/index";
import App from "./App.vue";
import $ from "jquery";
import axios from "axios";
import { redirectToError } from "@/utils/errorHandler.js";

//modal
import modal from "@/assets/js/modal";

const app = createApp(App);
window.$ = window.jQuery = $;
app.config.globalProperties.$ = $;

app.config.globalProperties.$modal = modal; //modal

let hasEnteredCurrentRoute = false;

router.beforeEach(() => {
    hasEnteredCurrentRoute = false;

    return true;
});

router.afterEach(() => {
    nextTick(() => {
        hasEnteredCurrentRoute = true;
    });
});

app.use(router);

const isPopupOpen = () => {
    if (typeof document === "undefined") return false;

    return !!document.querySelector(".modal_wrap.active, .common-popup-layer");
};

axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (!error?.config?.skipGlobalErrorHandler && !isPopupOpen() && !hasEnteredCurrentRoute) {
            redirectToError(router, { code: "500", reason: "api-error" });
        }

        return Promise.reject(error);
    }
);

app.mount("#app");
